<template>
  <div class="side-bar">
    <div class="side-item" @mouseenter="showQr = true" @mouseleave="showQr = false">
      <div class="side-icon">
        <i class="el-icon-office-building"></i>
      </div>
      <span class="side-label">公众号</span>
      <div class="qr-popup" v-show="showQr">
        <div class="qr-placeholder">
          <i class="el-icon-office-building"></i>
          <span>企业公众号</span>
        </div>
        <p class="qr-tip">扫码关注企业公众号</p>
      </div>
    </div>
    <div class="side-item" @mouseenter="showMini = true" @mouseleave="showMini = false">
      <div class="side-icon">
        <i class="el-icon-mobile-phone"></i>
      </div>
      <span class="side-label">小程序</span>
      <div class="qr-popup" v-show="showMini">
        <div class="qr-placeholder">
          <i class="el-icon-mobile-phone"></i>
          <span>小程序</span>
        </div>
        <p class="qr-tip">扫码进入小程序</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data() {
    return {
      showQr: false,
      showMini: false,
    };
  },
};
</script>

<style scoped lang="scss">
.side-bar {
  position: fixed;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.side-item {
  width: 60px;
  height: 60px;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  &:hover {
    background: #64b5f6;
    border-color: #64b5f6;
    box-shadow: 0 4px 16px rgba(66, 165, 245, 0.2);

    .side-icon i { color: #fff; }
    .side-label { color: #fff; }
  }

  .side-icon {
    i {
      font-size: 20px;
      color: #64b5f6;
      transition: color 0.3s;
    }
  }

  .side-label {
    font-size: 11px;
    color: #666;
    margin-top: 4px;
    transition: color 0.3s;
  }
}

.qr-popup {
  position: absolute;
  right: 72px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  padding: 16px;
  text-align: center;
  white-space: nowrap;

  .qr-placeholder {
    width: 140px;
    height: 160px;
    background: #f5f7fa;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #999;
    font-size: 13px;

    i {
      font-size: 36px;
      color: #64b5f6;
    }
  }

  .qr-tip {
    margin: 10px 0 0;
    font-size: 12px;
    color: #999;
  }
}

@media (max-width: 768px) {
  .side-bar {
    right: 4px;
  }
  .side-item {
    width: 48px;
    height: 48px;
    .side-label { display: none; }
    .side-icon i { font-size: 18px; }
  }
}
</style>
